export function cleanPhone(phone) {
  return phone.replace(/[ ()-]/ig, '');
}


export function cleanLink(link) {
  return link.replace(/^(http(s)?:\/\/)/gm, '');
}
